import React from 'react';
import { Input, Button, Card } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

import logo from './logo.png';

export const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900&family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap');

    body {
        font-family: 'Fira Sans', sans-serif;
    }
`;

export const Topbar = styled.div`
    position: relative;
    height: 70px;
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    background-image: url(${logo});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 200px;

    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 4px;
        background-color: #7f00ff;
        background-image: linear-gradient(90deg, #7f00ff 0%, #e100ff 100%);
        width: ${(props) => props.progress}%;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 50px;
    justify-content: space-between;
    width: 100%;
    max-width: 1000px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;

    @media (max-width: 768px) {
        button {
            display: none;
        }
    }

    transform: translateX(20px);
    animation: fadeInRight 0.5s ease-in-out forwards;

    @keyframes fadeInRight {
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 15px;
    justify-content: center;
    width: 100%;
    max-width: 1000px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;
    opacity: 0;
    transform: translateX(20px);
    animation: fadeInRight 0.5s ease-in-out forwards;

    @keyframes fadeInRight {
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 15px;
    justify-content: space-between;
    width: 100%;
    max-width: 1000px;
    padding: 0 20px;
    margin-left: auto;
    margin-right: auto;
    transform: translateX(20px);
    animation: fadeInRight 0.5s ease-in-out forwards;

    @keyframes fadeInRight {
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
`;

export const TextTitle = styled.div`
    text-align: left;
`;

export const StyledCard = styled(Card)`
    background-color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border-radius: 8px;
    font-family: 'Fira Sans', sans-serif;
`;

export const Title = styled.h1`
    text-align: left;
    margin-bottom: 5px;
    font-size: 30px;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 600;
    line-height: 1;
`;

export const Subtitle = styled.p`
    text-align: left;
    font-family: 'Fira Sans', sans-serif;
    font-size: 16px;
    color: #666;
    font-weight: 400;
`;

export const StyledInput = styled(Input)`
    height: 50px !important;
    font-family: 'Fira Sans', sans-serif;

    .ant-input {
        height: 50px !important;
        font-size: 15px;

        &::placeholder {
            color: #a9a9b8;
        }
    }
`;

export const PageShell = styled.div`
    min-height: calc(100vh - 70px);
    background: #f7f5fb;
    padding: 48px 16px 64px;

    @media (max-width: 480px) {
        padding: 20px 12px 40px;
    }
`;

export const FormCard = styled.div`
    max-width: 480px;
    margin: 0 auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(60, 20, 120, 0.08);
    padding: 36px 40px;
    opacity: 0;
    transform: translateY(14px);
    animation: cardIn 0.4s ease-out forwards;

    @keyframes cardIn {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 480px) {
        padding: 24px 20px;
        border-radius: 10px;
    }
`;

export const StepBadge = styled.div`
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #7f00ff;
    background: rgba(127, 0, 255, 0.08);
    border-radius: 20px;
    padding: 4px 12px;
    margin-bottom: 16px;
`;

export const CardTitle = styled.h1`
    font-family: 'Fira Sans', sans-serif;
    font-size: 26px;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 6px;
`;

export const CardSubtitle = styled.p`
    font-family: 'Fira Sans', sans-serif;
    font-size: 15px;
    color: #6b6b7b;
    margin-bottom: 24px;
`;

export const FieldLabel = styled.label`
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #3d3d4e;
    margin-bottom: 6px;
`;

export const LoginHint = styled.p`
    text-align: center;
    font-size: 14px;
    color: #6b6b7b;
    margin: 20px 0 0;

    a {
        color: #7f00ff;
        font-weight: 600;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const SummaryBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: #f7f5fb;
    border: 1px solid #ece8f6;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 24px;

    .summary-lines {
        min-width: 0;
    }

    .summary-company {
        font-size: 14px;
        font-weight: 600;
        color: #3d3d4e;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .summary-email {
        font-size: 13px;
        color: #6b6b7b;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    button {
        flex-shrink: 0;
    }
`;

export const ReqList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 14px 0 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px 12px;

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
`;

export const ReqItem = styled.li`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: ${(props) => (props.ok ? '#389e0d' : '#8c8c9a')};
    transition: color 0.2s;

    .anticon {
        font-size: 13px;
        color: ${(props) => (props.ok ? '#52c41a' : '#c9c9d4')};
    }
`;

export const StyledButton = styled(Button)`
    height: 50px !important;
    background-color: #7f00ff !important;
    border-color: #7f00ff !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
    font-family: 'Fira Sans', sans-serif;
    font-weight: 600 !important;
    font-size: 18px !important;
    &:hover {
        background-color: #7f00ff !important;
        border-color: #7f00ff !important;
    }
    &:focus {
        background-color: #7f00ff !important;
        border-color: #7f00ff !important;
    }
    &:active {
        background-color: #7f00ff !important;
        border-color: #7f00ff !important;
    }
    &[disabled] {
        background-color: #d8c9ef !important;
        border-color: #d8c9ef !important;
        color: #fff !important;
        box-shadow: none !important;
        cursor: not-allowed;
    }
`;